<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="fullscreen"
>
    <v-card>
        <v-card-title>
            Internet Explorer Detected
        </v-card-title>

        <v-card-text>
            RedChirp&trade; is not supported in Internet Explorer. We recommend you use RedChirp in Chrome or Safari.
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Ok
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            fullscreen: false,
        }
    },

    methods: {

        checkIfIE()
        {
            let ua = navigator.userAgent;

            if (ua === null) return false;

            /* MSIE used to detect old browsers and Trident used to newer ones*/
            var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
            
            return is_ie; 
        },

        showDialog()
        {
            this.fullscreen = false;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>